/**
 * Documents API - REST endpoints for Document Library features
 * 
 * NOTA: Este archivo usa la misma instancia de api que Api.js principal.
 * Se importa desde Api.js con spread: ...documentsApi
 * 
 * Los endpoints de búsqueda de estudiantes y classrooms ya existen en Api.js
 * (searchStudent, getCenterClassroom, getClassrooms), no se duplican aquí.
 */

import { Api } from 'auth-advenio'
import { API_DOMAIN } from '../../config'

const api = Api.createInstance((API_DOMAIN || 'http://api.soyadvenio.com'), 200000)

// Student Repository
const getStudentDocuments = (studentId, filters) =>
  api.get('miadvenio/students/' + studentId + '/documents', { params: filters })

const getStudentDocument = (studentId, documentId) =>
  api.get('miadvenio/students/' + studentId + '/documents/' + documentId)

const downloadStudentDocument = (studentId, documentId) =>
  api.get('miadvenio/students/' + studentId + '/documents/' + documentId + '/download', {
    responseType: 'blob',
  })

const deleteStudentDocument = (studentId, documentId) =>
  api.delete('miadvenio/students/' + studentId + '/documents/' + documentId)

// Document Library
const getDocuments = (filters) =>
  api.get('miadvenio/documents', { params: filters })

const getDocumentVersions = (documentId) =>
  api.get('miadvenio/documents/' + documentId + '/versions')

const getDocumentDistributionHistory = (documentId, filters) =>
  api.get('miadvenio/documents/' + documentId + '/distribution-history', { params: filters })

// Distribution (el endpoint ya existe en las rutas del backend)
const distributeDocument = (documentId, payload) =>
  api.post('miadvenio/documents/' + documentId + '/distribute', payload)

// Download version
const downloadVersion = (documentId, versionId) =>
  api.get('miadvenio/documents/' + documentId + '/versions/' + versionId + '/download', {
    responseType: 'blob'
  })

export default {
  studentDocuments: {
    get: getStudentDocuments,
    getOne: getStudentDocument,
    download: downloadStudentDocument,
    delete: deleteStudentDocument,
  },
  documents: {
    get: getDocuments,
    getVersions: getDocumentVersions,
    getDistributionHistory: getDocumentDistributionHistory,
    downloadVersion: downloadVersion,
  },
  distribution: {
    distribute: distributeDocument,
  },
}



// WEBPACK FOOTER //
// ./src/Data/Documents/documentsApi.js